/*
* Created on Jan 11, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import { useState, useEffect, useRef } from "react";

const useToggle = () => {
    /***
     * This Hook is used for toggle items to show/hide.
     * @Return
     * Open: The state of current component
     * node: The referenced element.
     * @type {React.MutableRefObject<undefined>}
     */
    const node = useRef();
    const [open, setOpen] = useState('hide');

    const collapse = () => {
        setOpen('hide');
    }

    const toggle = (e) => {
        // Check to see if the click is within the component itself.
        if (node.current && !node.current.contains(e.target)) {
            collapse();
        }
        else {
            setOpen((prevOpen) => prevOpen === 'hide' ? 'show' : 'hide' );
        }
    }

    useEffect(() => {
        // When mount a component
        document.addEventListener("click", toggle)

        // When unmount a component
        return () => {
            document.removeEventListener("click", toggle);
        }
    }, [])

    return [open, node]
}

export default useToggle;